export function getUserInitials(name) {
  if (typeof name !== "string" || !name.trim()) return "U";
  const names = name.trim().split(" ");
  if (names.length === 1) return names[0].charAt(0).toUpperCase();
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
}


// WEBPACK FOOTER //
// ./src/utils/initialName.js